import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

const filterOptionListGridAreaStyles = xcss({
	display: 'flex',
	flexDirection: 'column',
	gap: 'space.200',
	width: '100%',
});

const filterOptionStyles = xcss({
	display: 'flex',
	gap: 'space.100',
	alignItems: 'center',
	paddingInline: 'space.150',
});

const baseStyles = xcss({
	backgroundColor: 'color.background.accent.gray.subtlest',
	borderRadius: 'radius.small',
});

const iconStyles = xcss({
	width: 'size.200',
	height: 'size.200',
});

const contentStyles = xcss({
	height: token('space.200'),
});

const textStyles = xcss({
	flex: 'auto',
});

const countStyles = xcss({
	width: 'size.300',
});

const FilterOptionSkeleton = () => {
	return (
		<Box xcss={filterOptionStyles}>
			<Box xcss={[baseStyles, iconStyles]} />
			<Box xcss={[baseStyles, contentStyles, textStyles]} />
			<Box xcss={[baseStyles, contentStyles, countStyles]} />
		</Box>
	);
};

export const SidebarLoading = (): React.JSX.Element => {
	return (
		<Box xcss={filterOptionListGridAreaStyles} testId="app-filter-sidebar-loading">
			<FilterOptionSkeleton />
			<FilterOptionSkeleton />
			<FilterOptionSkeleton />
			<FilterOptionSkeleton />
			<FilterOptionSkeleton />
			<FilterOptionSkeleton />
			<FilterOptionSkeleton />
			<FilterOptionSkeleton />
			<FilterOptionSkeleton />
			<FilterOptionSkeleton />
		</Box>
	);
};
